import { EventResponse } from '@goldcast/api/backend';

export interface State {
  searchTerm: string;
  events: Events;
  filterBy: FilterBy;
  sortBy: SortBy;
  selectedTagIds: string[];
  workspaceId: string;
  repeatingEventFilter: RepeatingEventFilterItemsEnum;
  isLoading: boolean;
  currentPage: number;
  eventsPerPage: number;
  eventsCount: number;
  currentEventId: string;
  isUpdateEventLoading: boolean;
  isIntegrationTemplateDataLoadingAndUpdatingEvent: boolean;
  eventTypes: EventListFilter;
  lastOpenedPage: ListPageType;
}

export type ThemeObj = {
  logos: string[];
  font_type: string;
  auth_theme: boolean;
  show_borders: boolean;
  sidebar_blur: string;
  sidebar_alpha: number;
  disallow_login: boolean;
  page_item_alpha: number;
  theme_font_name: string;
  event_background: string;
  name_card_radius: string;
  splash_font_type: string;
  splash_page_hero: string;
  stage_background: string;
  stage_text_color: string;
  accent_text_color: string;
  onEditScreenSaver: boolean;
  splash_text_color: string;
  primary_text_color: string;
  theme_accent_color: string;
  theme_primary_color: string;
  virtual_backgrounds: string[];
  ctrl_bar_shade_alpha: string;
  name_card_background: string;
  name_card_text_color: string;
  secondary_text_color: string;
  theme_secondary_color: string;
  lower_third_background: string;
  lower_third_text_color: string;
  splash_gradient_height: string;
  splash_theme_font_name: string;
  stage_background_shade: string;
  mobile_event_background: string;
  mobile_splash_page_hero: string;
  mobile_stage_background: string;
  name_card_title_display: string;
  screen_saver_background: string;
  screen_saver_text_color: string;
  splash_background_color: string;
  splash_background_shade: string;
  primary_background_shade: string;
  alt_primary_background_shade: string;
};

export type Events = {
  [id: string]: EventResponse;
};

export interface Params {
  searchTerm: string;
  filterBy: FilterBy;
  sortBy: SortBy;
  currentPage: number;
  tags: string[];
  eventTypes: EventListFilter;
  workspaceId: string;
  repeatingEventFilter: RepeatingEventFilterItemsEnum;
}

/* eslint-disable no-unused-vars */
export const enum FilterBy {
  AllEvents,
  UpcomingEvents,
  PastEvents,
  UpcomingNonLiveEvents,
  OnDemandEvents
}

export const enum SortBy {
  TitleDescending,
  TitleAscending,
  EventDateDescending,
  EventDateAscending
}

export const enum EventListFilter {
  AllEvents,
  Webinar,
  Conference,
  Recording
}

export const enum ListPageType {
  Recording,
  Event
}

export enum RepeatingEventFilterItemsEnum {
  SHOW = '',
  HIDE = 'default',
  SHOW_ONLY = 'repeating'
}

/* eslint-enable no-unused-vars */
